export enum IbanTercihiEnum {
    Avukat = "Avukat",
    Muvekkil = "Müvekkil",
    Yok = "Yok"
}
